import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const PasswordField = ({ value, ...props }) => {
  const [shown, setShown] = useState(false);

  return (
    <TextField
      {...props}
      type={shown ? 'text' : 'password'}
      value={value}
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value && (
              <Typography className={'password-toggler'} onClick={() => setShown(!shown)}>
                {shown ? 'hide' : 'show'}
              </Typography>
            )}
          </InputAdornment>
        ),
      }}
      fullWidth
    />
  );
};

export default PasswordField;
